import Blue from "~/core";
import {remove} from 'lodash-es'

new Blue({
	name: 'Filters',
	selector: ".filters",
	setup(filters) {
		const items = [...filters.querySelectorAll('.filters__wrapper--custom')];
		items.forEach(el => {
			const active = el.querySelector('.filters__active');
			const menu = el.querySelector('.filters__menu');
			const value = el.querySelector('.filters__value');
			const options = [...el.querySelectorAll('.filters__input')];
			const placeholder = el.dataset.placeholder;
			const selectAll = el.dataset.selectall && el.dataset.selectall !== "false";
			const isMultiple = el.dataset.multiple && el.dataset.multiple !== "false";
			let selections = [];
			
			options.forEach((o) => { 
				if(o.checked){
					selections.push(o.value);
				} 
			});

			const toggle = () => {
				if (el.classList.contains('is-active')) {
					items.forEach(el => { el.classList.remove('is-active'); })
				} else {
					items.forEach(el => { el.classList.remove('is-active'); })
					el.classList.add('is-active');
				}
			};

			active.classList.add('has-placeholder')
			active.textContent = placeholder

			if (isMultiple) {
				if (selectAll) {
					const label = document.createElement("label");
					const input = document.createElement("input");
					const span = document.createElement("span");

					label.classList.add("filters__option");

					input.classList.add("filters__input");
					input.classList.add("filters__input-all");
					input.type = "checkbox";
					input.value = "Select All";

					span.classList.add("filters__label");
					span.innerHTML = "Select All";

					label.append(input);
					label.append(span);
					menu.prepend(label);
				}

				const allInput = el.querySelector('.filters__input-all');

				const selectAllEvent = (e) => {
					if (e.target.checked) {
						selections = [];
						selections.push('All Selected');
						options.forEach((o) => {
							o.checked = true;
						});
					} else {
						selections = [];
						options.forEach((o) => {
							o.checked = false;
						});
					}
					setDisplay();
				}
				if (allInput) {
					this.$addEvents(allInput, 'input', selectAllEvent);
				}
			}

			const setDisplay = () => {
				const values = selections.join(',')
				const display = []
				selections.forEach(s => {
					if (s === 'All Selected') {
						display.push(s);
					} else {
						let option = options.find(o => o.value === s)
						display.push(option.nextElementSibling.textContent);
					}
				});
				display.sort();
				value.value = values;
				if (display.length > 0) {
					active.classList.remove('has-placeholder')
					active.textContent = display.join(', ');
				} else {
					active.classList.add('has-placeholder')
					active.textContent = placeholder
				}
			}

			const select = (e) => {
				if (isMultiple) {
					if (selections.includes('All Selected')) {
						selections = [];
						allInput.checked = false;
						options.forEach((o) => {
							selections.push(o.value);
						});
					}

					if (e.target.checked) {
						selections.push(e.target.value);
					}
					else {
						remove(selections, s => s===e.target.value);
					}
				} else {
					selections = [];
					options.forEach((o) => { o.checked = false; });
					e.target.checked = true;
					selections.push(e.target.value);
				}
				setDisplay();
			}

			this.$addEvents(active, 'click.stop.prevent enter.stop.prevent', () => toggle());
			options.forEach(o => this.$addEvents(o, 'input', select));

		})
	}
});
